import _styled from '@emotion/styled/base';
import { Box } from '@mui/material';
import Slider from '@mui/material/Slider';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const StyledLabelContainer = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "eays9b61"
})(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '8px',
  color: '#A5A5A5',
  fontSize: '12px',
  fontWeight: 500
}), "");
const StyledSlider = /*#__PURE__*/_styled(Slider, {
  shouldForwardProp: isStyledPropsValid,
  target: "eays9b60"
})(_ref => {
  let {
    theme
  } = _ref;
  return {
    padding: 0,
    marginBottom: 0,
    color: theme.customColors.purple[500],
    height: '2px',
    '& .MuiSlider-rail': {
      backgroundColor: '#E6E6E6'
    },
    '& .MuiSlider-markLabel': {
      transform: 'unset',
      color: "".concat(theme.customColors.grey[700], " !important")
    },
    '& .MuiSlider-markLabel[data-index="0"]': {
      top: '-5px',
      left: '-16px !important'
    },
    '& .MuiSlider-markLabel[data-index="1"]': {
      top: '-5px',
      right: '-21px !important',
      left: 'unset !important'
    },
    '& .MuiSlider-mark': {
      display: 'none'
    },
    '& .MuiSlider-thumb': {
      height: '16px',
      width: '16px',
      border: "1px solid #E6E6E6",
      backgroundColor: '#fff',
      borderRadius: '50%',
      // 確保是圓形
      outline: 'none',
      // 移除藍色邊框
      boxShadow: 'none',
      // 避免 hover 或 focus 時產生陰影
      '&:hover': {
        boxShadow: 'none' // 禁用 hover 狀態下的陰影
      },
      '&.Mui-focusVisible': {
        boxShadow: 'none' // 禁用 focus 時的陰影
      },
      '&:active': {
        boxShadow: 'none' // 禁用 drag 狀態下的陰影
      }
    }
  };
}, "");
export { StyledLabelContainer, StyledSlider };